import { productChannel, useEventBusEmit } from '@haus-storefront-react/core'
import { useProduct } from '@haus-storefront-react/hooks'
import { useEffect } from 'react'
import { getVendureProductId } from '../../utilities/utilities'

interface ProductPageViewEventProps {
  isEditMode: boolean
}

export const ProductPageViewEvent = ({ isEditMode }: ProductPageViewEventProps) => {
  const vendureProductId = getVendureProductId()
  const { data: product } = useProduct({ id: vendureProductId }, !!vendureProductId)
  const emitViewItem = useEventBusEmit(productChannel, 'product:viewed')
  const emitSelectedProductVariant = useEventBusEmit(productChannel, 'product:variant:selected')

  useEffect(() => {
    if (product) {
      const firstVariant = product.variants?.[0]
      if (firstVariant) {
        emitSelectedProductVariant(firstVariant)
      }

      if (!isEditMode) {
        emitViewItem(product)
      }
    }
  }, [product, emitViewItem, emitSelectedProductVariant, isEditMode])

  return null
}

export default ProductPageViewEvent
